import StudentLayout from "../../modules/student/pages/Student";
//
// Layouts
import StudentDashboard from "../../modules/student/layouts/dashboard/StudentDashboard";
// Courses
import StudentCourses from "../../modules/student/layouts/courses/StudentCourses";
import StudentCourseContent from "../../modules/student/layouts/courses/StudentCourseContent";
import StudentCourseReading from "../../modules/student/layouts/courses/StudentCourseReading";
// Challenges
import Challenge from "../../modules/challenge/layouts/ChallengeContainer";
import ChallengeContent from "../../modules/challenge/layouts/ChallengeContent";
// Discussion
import Discussion from "../../modules/discussion/layout/Discussion";
import NotificationContainer from "../../modules/discussion/components/notification-container/NotificationContainer";
import DiscussionContainer from "../../modules/discussion/components/discussion-container/DiscussionContainer";
//
import Settings from "../../modules/setting/Settings";

export const studentRoutes = [
  {
    path: "/student",
    element: <StudentLayout />,
    children: [
      { path: "", element: <StudentDashboard /> },
      {
        path: "courses",
        element: <StudentCourses />,
        children: [
          { path: "", element: <StudentCourseContent /> }, // /student/courses
          { path: ":course_title/reading", element: <StudentCourseReading /> }, // /student/courses/:course_title/reading
        ],
      },
      {
        path: "challenges",
        element: <Challenge />,
        children: [{ path: "", element: <ChallengeContent /> }],
      },
      {
        path: "discussions",
        element: <Discussion />,
        children: [
          { path: "", element: <NotificationContainer /> },
          { path: "messages", element: <DiscussionContainer /> },
        ],
      },
      { path: "settings", element: <Settings /> },
    ],
  },
];
